var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.24 10.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68,1.4l6.56-1.4v7.22c0,.75-1,2.2-2,2.2-.44,0-.83-.29-.83-.76,0-.38.27-.88.97-1.43.93-.59,1.44-.1,1.44-.68v-3.02l-5.72,1.26v3.48c0,1.41-1.32,2.58-2.51,2.58-.37,0-.6-.25-.6-.59,0-.47.41-1.12,1.4-1.58.83-.27,1.28-.01,1.28-.8V1.4ZM3.11,3.44l5.72-1.32v-.65l-5.72,1.24v.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdButton);
export default __webpack_public_path__ + "static/media/CD-button.8af5f207b7f74a1db01a1d3c7e29cb29.svg";
export { ForwardRef as ReactComponent };